import {
  makePaginationState,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';


const initialState = {
  stories: makePaginationState(),
};


export default (state = initialState, action) => {
  switch (action.type) {
    // fetch user stories
    case `${t.FETCH_MY_STORIES}_PENDING`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MY_STORIES}_SUCCESS`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.stories.pagination.items
              .concat(action.payload.result.items),
          },
        },
      };
    case `${t.FETCH_MY_STORIES}_ERROR`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.ERROR,
        },
      };

    // reset
    case t.RESET:
      return {
        ...state,
        stories: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/myPage/reducer.js